import axios from "../../axios";

const getInvoiceById = async (invoice_id) => {
  try {
    const { data } = await axios.get(`/invoices/${invoice_id}`);
    return data;
  } catch (e) {
    throw e;
  }
}

const getAppliedPayments = async (invoice_id) => {
  try {
    const { data } = await axios.get(`/invoices/applied_payments/${invoice_id}`);
    return data;
  } catch (e) {
    throw e;
  }
};

const getInvoicesByCustomer = async (customer_id, status, invoice_id) => {
  console.log(customer_id, status, invoice_id, "getInvoicesByCustomer");
  status = status === "open" ? `?paid_status[$ne]=paid` : '';
  let query = status ? "&" : '?';
  invoice_id = invoice_id ? `${query}invoice_id[$ne]=${invoice_id}` : ''; // exclude current invoice
  try {
    const { data } = await axios.get(`/invoices/customer/${customer_id}${status}${invoice_id}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const deleteInvoice = async (invoice_id) => {
  try {
    const { data } = await axios.delete(`/invoices/${invoice_id}`);
    return data;
  } catch (e) {
    throw e;
  }
};

const getInvoiceStats = async () => {
  try {
    const { data } = await axios.get(`/invoices/stats`);
    return data;
  } catch (e) {
    throw e;
  }
};

export { getInvoicesByCustomer, getAppliedPayments, deleteInvoice, getInvoiceById, getInvoiceStats };